import { styled } from '@arpeggi/ui'
import { ArpeggiLogo } from '../../../__legacy__/components/platform/icons'

const Root = styled('div', {
  display: 'flex',
  alignItems: 'center',
  fontSize: '18px',
  lineHeight: '24px',
  fontFamily: 'Poppins',
  fontWeight: 500,
  color: '$white',
  cursor: 'pointer',
  userSelect: 'none'
})

const Text = styled('span', {
  display: 'none',
  '@tablet': { display: 'inline' }
})

const Icon = styled(ArpeggiLogo, {
  marginRight: '12px',
  width: '24px',
  height: '24px'
})

export const Logo = { Root, Text, Icon }
